var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSilverBadgeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 32,
    viewBox: "0 0 23 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_743_369)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.9762 0L15.3648 8.82348H7.89062L11.211 0H18.9762Z",
    fill: "#892020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.71 7.30176H7.61413C7.08498 7.30176 6.64844 7.7383 6.64844 8.26745V13.4266H16.6757V8.26745C16.6757 7.72507 16.2392 7.30176 15.71 7.30176ZM15.9614 9.19345H7.17758V8.79659C7.17758 8.37327 7.52153 8.0161 7.95807 8.0161H15.1941C15.6174 8.0161 15.9746 8.36005 15.9746 8.79659V9.19345H15.9614Z",
    fill: "#9EA8BA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.39844 0L7.89079 8.82348H15.365L11.9652 0H4.39844Z",
    fill: "#FA352C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.26795 8.82348L5.70946 0H5.14062L8.69912 8.82348H9.26795Z",
    fill: "#FF740D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.014 8.82348L7.45555 0H6.88672L10.4452 8.82348H11.014Z",
    fill: "#FF740D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12.6937 8.82348L9.13524 0H8.56641L12.1249 8.82348H12.6937Z",
    fill: "#FF740D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M14.4945 8.82348L10.9492 0H10.3672L13.9257 8.82348H14.4945Z",
    fill: "#FF740D"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M22.2294 22.5377C23.0095 16.5832 18.8149 11.1238 12.8604 10.3437C6.90598 9.56357 1.44654 13.7582 0.666428 19.7127C-0.113686 25.6671 4.08094 31.1265 10.0354 31.9067C15.9898 32.6868 21.4493 28.4921 22.2294 22.5377Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M11.4503 10.252C11.3445 10.252 11.2386 10.252 11.1328 10.252C16.9931 10.4239 21.6892 15.2259 21.6892 21.1259C21.6892 27.0258 16.9931 31.8278 11.1328 31.9998C11.2386 31.9998 11.3445 31.9998 11.4503 31.9998C17.4561 31.9998 22.3242 27.1317 22.3242 21.1259C22.3242 15.1201 17.4561 10.252 11.4503 10.252Z",
    fill: "#9EA8BA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M20.2348 22.2765C20.8707 17.4232 17.4517 12.9732 12.5983 12.3374C7.74491 11.7015 3.295 15.1205 2.65914 19.9739C2.02328 24.8273 5.44226 29.2772 10.2956 29.913C15.149 30.5489 19.5989 27.1299 20.2348 22.2765Z",
    fill: "#9EA8BA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M11.1719 23.6738H13.8838V25.0099H9.01562V23.6209C9.86226 22.8933 11.9921 21.1207 11.9921 20.0095C11.9921 19.4539 11.6217 19.0703 11.0131 19.0703C10.4046 19.0703 9.78288 19.3084 9.24051 19.5862L9.1876 18.1046C12.8651 16.6494 14.8891 18.9776 13.1562 21.5308C12.7461 22.179 12.0847 22.8801 11.1719 23.6738Z",
    fill: "#373B43"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M10.3631 27.291C10.7071 27.5688 10.7997 28.0186 10.7997 28.0186C10.7997 28.0186 10.3367 28.0318 9.97951 27.754C9.63557 27.4762 9.54297 27.0265 9.54297 27.0265C9.54297 27.0265 10.0192 27.0132 10.3631 27.291Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M9.93877 28.0057C10.3621 27.8602 10.7986 28.019 10.7986 28.019C10.7986 28.019 10.5605 28.4158 10.1372 28.5613C9.71389 28.7069 9.27734 28.5481 9.27734 28.5481C9.27734 28.5481 9.52869 28.1513 9.93877 28.0057Z",
    fill: "#BAC6D8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M9.01726 26.9202C9.32152 27.2377 9.34797 27.7007 9.34797 27.7007C9.34797 27.7007 8.88497 27.6478 8.58072 27.3303C8.27646 27.0128 8.25 26.5498 8.25 26.5498C8.25 26.5498 8.713 26.6027 9.01726 26.9202Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M8.50101 27.5683C8.93755 27.4757 9.34764 27.7005 9.34764 27.7005C9.34764 27.7005 9.05661 28.0577 8.62007 28.1503C8.18352 28.2429 7.77344 28.018 7.77344 28.018C7.77344 28.018 8.06447 27.6609 8.50101 27.5683Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M7.94404 26.3908C8.19539 26.748 8.14247 27.211 8.14247 27.211C8.14247 27.211 7.6927 27.0919 7.44136 26.7215C7.19001 26.3644 7.24293 25.9014 7.24293 25.9014C7.24293 25.9014 7.6927 26.0337 7.94404 26.3908Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M7.33669 26.9604C7.78646 26.9472 8.15686 27.225 8.15686 27.225C8.15686 27.225 7.81292 27.5425 7.36314 27.5557C6.91337 27.5689 6.54297 27.2911 6.54297 27.2911C6.54297 27.2911 6.88691 26.9736 7.33669 26.9604Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M6.95037 25.5979C7.10912 26.008 6.95037 26.4445 6.95037 26.4445C6.95037 26.4445 6.54029 26.2196 6.39477 25.8095C6.23603 25.3994 6.39477 24.9629 6.39477 24.9629C6.39477 24.9629 6.79163 25.1878 6.95037 25.5979Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M6.22554 25.994C6.66208 26.0866 6.95311 26.4438 6.95311 26.4438C6.95311 26.4438 6.54302 26.6687 6.10648 26.5761C5.66994 26.4835 5.37891 26.1263 5.37891 26.1263C5.37891 26.1263 5.78899 25.9014 6.22554 25.994Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M6.19754 24.6583C6.25046 25.0949 5.98589 25.4785 5.98589 25.4785C5.98589 25.4785 5.64194 25.161 5.58903 24.7245C5.53611 24.2879 5.80069 23.9043 5.80069 23.9043C5.80069 23.9043 6.14463 24.235 6.19754 24.6583Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M5.39111 24.8831C5.78797 25.0683 5.9864 25.4916 5.9864 25.4916C5.9864 25.4916 5.53662 25.6107 5.12654 25.4255C4.72968 25.2403 4.53125 24.817 4.53125 24.817C4.53125 24.817 4.99425 24.6979 5.39111 24.8831Z",
    fill: "#BAC6D8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M5.5635 23.4935C5.52382 23.93 5.1931 24.2607 5.1931 24.2607C5.1931 24.2607 4.92853 23.8771 4.95498 23.4538C4.99467 23.0172 5.32539 22.6865 5.32539 22.6865C5.32539 22.6865 5.58996 23.0569 5.5635 23.4935Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M4.73033 23.5465C5.0875 23.811 5.19333 24.2608 5.19333 24.2608C5.19333 24.2608 4.73033 24.2873 4.37316 24.0227C4.01599 23.7581 3.91016 23.3084 3.91016 23.3084C3.91016 23.3084 4.37316 23.2819 4.73033 23.5465Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M5.23039 22.3822C5.12456 22.8055 4.74093 23.0833 4.74093 23.0833C4.74093 23.0833 4.52927 22.6733 4.6351 22.2499C4.74093 21.8266 5.12456 21.5488 5.12456 21.5488C5.12456 21.5488 5.33622 21.9589 5.23039 22.3822Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M4.39768 22.3035C4.70193 22.6209 4.74162 23.084 4.74162 23.084C4.74162 23.084 4.27862 23.031 3.96113 22.7268C3.65687 22.4093 3.61719 21.9463 3.61719 21.9463C3.61719 21.9463 4.08019 21.986 4.39768 22.3035Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M5.19322 21.1391C4.98156 21.5227 4.54502 21.6947 4.54502 21.6947C4.54502 21.6947 4.45242 21.2449 4.65085 20.8613C4.86251 20.4776 5.29905 20.3057 5.29905 20.3057C5.29905 20.3057 5.40488 20.7554 5.19322 21.1391Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M4.39768 20.8612C4.62256 21.2448 4.54319 21.6946 4.54319 21.6946C4.54319 21.6946 4.10665 21.5358 3.88176 21.1654C3.65688 20.7818 3.73625 20.332 3.73625 20.332C3.73625 20.332 4.18602 20.4908 4.39768 20.8612Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M5.41809 19.8826C5.12706 20.2133 4.66406 20.2794 4.66406 20.2794C4.66406 20.2794 4.67729 19.8164 4.96832 19.4857C5.25935 19.155 5.72235 19.0889 5.72235 19.0889C5.72235 19.0889 5.70912 19.5519 5.41809 19.8826Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M4.71347 19.4325C4.84576 19.8558 4.64733 20.2791 4.64733 20.2791C4.64733 20.2791 4.25047 20.0278 4.13141 19.6044C3.99912 19.1811 4.19755 18.7578 4.19755 18.7578C4.19755 18.7578 4.58118 19.0092 4.71347 19.4325Z",
    fill: "#BAC6D8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M5.86465 18.8509C5.50748 19.1022 5.03125 19.0625 5.03125 19.0625C5.03125 19.0625 5.15031 18.6127 5.50748 18.3614C5.86465 18.1101 6.34088 18.1497 6.34088 18.1497C6.34088 18.1497 6.22182 18.5995 5.86465 18.8509Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M5.28456 18.2555C5.31102 18.6921 5.03322 19.0625 5.03322 19.0625C5.03322 19.0625 4.71573 18.7318 4.68928 18.2952C4.66282 17.8587 4.94062 17.4883 4.94062 17.4883C4.94062 17.4883 5.25811 17.819 5.28456 18.2555Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M6.43408 17.912C6.03722 18.1105 5.57422 17.9914 5.57422 17.9914C5.57422 17.9914 5.75942 17.5681 6.15628 17.3697C6.55314 17.1712 7.01614 17.2903 7.01614 17.2903C7.01614 17.2903 6.83094 17.7268 6.43408 17.912Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M5.96023 17.2372C5.92054 17.6737 5.5766 17.9912 5.5766 17.9912C5.5766 17.9912 5.31203 17.6076 5.35171 17.171C5.3914 16.7345 5.73534 16.417 5.73534 16.417C5.73534 16.417 5.99991 16.8006 5.96023 17.2372Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M12.7725 27.2373C12.4285 27.5151 12.3359 27.9649 12.3359 27.9649C12.3359 27.9649 12.7989 27.9781 13.1561 27.7003C13.5001 27.4225 13.5927 26.9728 13.5927 26.9728C13.5927 26.9728 13.1164 26.9595 12.7725 27.2373Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M13.1958 27.9384C12.7725 27.7929 12.3359 27.9516 12.3359 27.9516C12.3359 27.9516 12.5741 28.3485 12.9974 28.494C13.4207 28.6395 13.8572 28.4807 13.8572 28.4807C13.8572 28.4807 13.6059 28.0839 13.1958 27.9384Z",
    fill: "#BAC6D8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M13.9479 26.9202C13.6436 27.2377 13.6172 27.7007 13.6172 27.7007C13.6172 27.7007 14.0802 27.6478 14.3844 27.3303C14.6887 27.0128 14.7152 26.5498 14.7152 26.5498C14.7152 26.5498 14.2522 26.6027 13.9479 26.9202Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M14.4638 27.5692C14.0273 27.4766 13.6172 27.7015 13.6172 27.7015C13.6172 27.7015 13.9082 28.0587 14.3448 28.1513C14.7813 28.2439 15.1914 28.019 15.1914 28.019C15.1914 28.019 14.9004 27.6618 14.4638 27.5692Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M15.0195 26.3518C14.7681 26.7089 14.8211 27.1719 14.8211 27.1719C14.8211 27.1719 15.2708 27.0529 15.5222 26.6825C15.7735 26.3253 15.7206 25.8623 15.7206 25.8623C15.7206 25.8623 15.2708 25.9946 15.0195 26.3518Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M15.6288 26.9077C15.179 26.8945 14.8086 27.1723 14.8086 27.1723C14.8086 27.1723 15.1525 27.4897 15.6023 27.503C16.0521 27.5162 16.4225 27.2384 16.4225 27.2384C16.4225 27.2384 16.0653 26.9341 15.6288 26.9077Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M15.9729 25.5715C15.8142 25.9816 15.9729 26.4181 15.9729 26.4181C15.9729 26.4181 16.383 26.1932 16.5285 25.7832C16.6872 25.3731 16.5285 24.9365 16.5285 24.9365C16.5285 24.9365 16.1316 25.1614 15.9729 25.5715Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M16.7119 25.9687C16.2754 26.0613 15.9844 26.4184 15.9844 26.4184C15.9844 26.4184 16.3945 26.6433 16.831 26.5507C17.2676 26.4581 17.5586 26.1009 17.5586 26.1009C17.5586 26.1009 17.1353 25.8761 16.7119 25.9687Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M16.7648 24.5792C16.7119 25.0158 16.9765 25.3994 16.9765 25.3994C16.9765 25.3994 17.3204 25.0819 17.3733 24.6454C17.4262 24.2088 17.1617 23.8252 17.1617 23.8252C17.1617 23.8252 16.8177 24.1427 16.7648 24.5792Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M17.5718 24.7913C17.175 24.9765 16.9766 25.3998 16.9766 25.3998C16.9766 25.3998 17.4263 25.5189 17.8364 25.3337C18.2333 25.1485 18.4317 24.7252 18.4317 24.7252C18.4317 24.7252 17.9687 24.6061 17.5718 24.7913Z",
    fill: "#BAC6D8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M17.3359 23.4681C17.3756 23.9046 17.7063 24.2353 17.7063 24.2353C17.7063 24.2353 17.9709 23.8517 17.9444 23.4284C17.9047 22.9918 17.574 22.6611 17.574 22.6611C17.574 22.6611 17.2962 23.0448 17.3359 23.4681Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M18.17 23.5205C17.8129 23.785 17.707 24.2348 17.707 24.2348C17.707 24.2348 18.17 24.2613 18.5272 23.9967C18.8844 23.7321 18.9902 23.2823 18.9902 23.2823C18.9902 23.2823 18.5272 23.2691 18.17 23.5205Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M17.6664 22.3568C17.7722 22.7802 18.1558 23.058 18.1558 23.058C18.1558 23.058 18.3675 22.6479 18.2616 22.2246C18.1558 21.8012 17.7722 21.5234 17.7722 21.5234C17.7722 21.5234 17.5605 21.9335 17.6664 22.3568Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M18.5002 22.2771C18.1959 22.5946 18.1562 23.0576 18.1562 23.0576C18.1562 23.0576 18.6193 23.0047 18.9367 22.7004C19.241 22.3829 19.2807 21.9199 19.2807 21.9199C19.2807 21.9199 18.8045 21.9596 18.5002 22.2771Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M17.7065 21.1527C17.9182 21.5364 18.3547 21.7083 18.3547 21.7083C18.3547 21.7083 18.4473 21.2586 18.2489 20.8749C18.0372 20.4913 17.6007 20.3193 17.6007 20.3193C17.6007 20.3193 17.4948 20.7691 17.7065 21.1527Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M18.4872 20.8748C18.2623 21.2585 18.3417 21.7083 18.3417 21.7083C18.3417 21.7083 18.7783 21.5495 19.0031 21.1791C19.228 20.7955 19.1487 20.3457 19.1487 20.3457C19.1487 20.3457 18.7121 20.5044 18.4872 20.8748Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M17.4683 19.8963C17.7593 20.227 18.2224 20.2931 18.2224 20.2931C18.2224 20.2931 18.2091 19.8301 17.9181 19.4994C17.6271 19.1687 17.1641 19.1025 17.1641 19.1025C17.1641 19.1025 17.1773 19.5655 17.4683 19.8963Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M18.1705 19.4461C18.0382 19.8695 18.2366 20.2928 18.2366 20.2928C18.2366 20.2928 18.6335 20.0414 18.7525 19.6181C18.8848 19.1948 18.6864 18.7715 18.6864 18.7715C18.6864 18.7715 18.2895 19.0361 18.1705 19.4461Z",
    fill: "#BAC6D8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M17.0309 18.8772C17.3881 19.1286 17.8643 19.0889 17.8643 19.0889C17.8643 19.0889 17.7453 18.6391 17.3881 18.3878C17.0309 18.1364 16.5547 18.1761 16.5547 18.1761C16.5547 18.1761 16.6605 18.6259 17.0309 18.8772Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M17.5994 18.2956C17.573 18.7321 17.8508 19.1025 17.8508 19.1025C17.8508 19.1025 18.1683 18.7718 18.1947 18.3353C18.2212 17.8987 17.9434 17.5283 17.9434 17.5283C17.9434 17.5283 17.6259 17.859 17.5994 18.2956Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M16.4219 17.9511C16.8188 18.1495 17.2818 18.0305 17.2818 18.0305C17.2818 18.0305 17.0966 17.6072 16.6997 17.4087C16.3028 17.2103 15.8398 17.3294 15.8398 17.3294C15.8398 17.3294 16.025 17.7659 16.4219 17.9511Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M16.8986 17.2762C16.9383 17.7128 17.2822 18.0303 17.2822 18.0303C17.2822 18.0303 17.5468 17.6466 17.5071 17.2101C17.4674 16.7735 17.1235 16.4561 17.1235 16.4561C17.1235 16.4561 16.8589 16.8529 16.8986 17.2762Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M16.106 16.6289C16.0928 16.6421 16.0663 16.6686 16.0399 16.6818C16.0266 16.6818 16.0266 16.695 16.0134 16.695C17.4024 17.8856 18.2755 19.5921 18.2755 21.497C18.2755 25.0688 15.2065 27.9658 11.4231 27.9658C7.63971 27.9658 4.57067 25.0688 4.57067 21.497C4.57067 19.6715 5.37762 18.0311 6.66079 16.8538C6.62111 16.8406 6.58142 16.8273 6.55496 16.8141C5.27179 18.0047 4.46484 19.6715 4.46484 21.497C4.46484 25.1217 7.58679 28.0717 11.4231 28.0717C15.2594 28.0717 18.3813 25.1217 18.3813 21.497C18.3946 19.5657 17.5083 17.8327 16.106 16.6289Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M7.36226 17.0918C6.92571 17.1844 6.51562 16.9728 6.51562 16.9728C6.51562 16.9728 6.80665 16.6024 7.2432 16.5098C7.67974 16.4172 8.08983 16.6288 8.08983 16.6288C8.08983 16.6288 7.78557 16.9992 7.36226 17.0918Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M7.05602 16.3242C6.91051 16.7343 6.50042 16.9724 6.50042 16.9724C6.50042 16.9724 6.34168 16.5358 6.48719 16.1257C6.63271 15.7157 7.0428 15.4775 7.0428 15.4775C7.0428 15.4775 7.21477 15.9141 7.05602 16.3242Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M15.5479 17.0918C15.9844 17.1844 16.3945 16.9728 16.3945 16.9728C16.3945 16.9728 16.1035 16.6024 15.6669 16.5098C15.2304 16.4172 14.8203 16.6288 14.8203 16.6288C14.8203 16.6288 15.1113 16.9992 15.5479 17.0918Z",
    fill: "#BAC6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M15.8388 16.3242C15.9843 16.7343 16.3944 16.9724 16.3944 16.9724C16.3944 16.9724 16.5531 16.5358 16.4076 16.1257C16.2621 15.7157 15.852 15.4775 15.852 15.4775C15.852 15.4775 15.6932 15.9141 15.8388 16.3242Z",
    fill: "#BAC6D8"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_743_369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.7478,
    height: 32,
    fill: "white",
    transform: "translate(0.574219)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverBadgeIcon);
export default __webpack_public_path__ + "static/media/silverBadgeIcon.86d613fad4679eb0138fd50a8d5c0f57.svg";
export { ForwardRef as ReactComponent };